import Marquee from "react-fast-marquee";
import { Siren } from "lucide-react";

const ALERTS = [
  "Fake CRA refund calls hitting 403 numbers",
  "'Grandparent emergency' text scams on the rise in YYC",
  "Phishing emails disguised as Enmax utility bills",
  "Fake Canada Post 'redelivery fee' texts",
  "Kijiji & Marketplace e-transfer scams targeting sellers",
  "Fake bank 'fraud department' calls asking for one-time codes",
];

export default function ScamTicker() {
  return (
    <section id="scam-alerts" className="bg-accent text-accent-foreground py-4 border-y border-border scroll-mt-24" data-testid="scam-ticker-section">
      <Marquee speed={45} gradient={false} pauseOnHover>
        {ALERTS.map((alert) => (
          <span key={alert} className="inline-flex items-center gap-3 mx-8" data-testid="scam-ticker-item">
            <Siren className="w-4 h-4 shrink-0" strokeWidth={2} />
            <span className="font-display font-medium text-sm tracking-wide uppercase">{alert}</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
